import {
  Tooltip,
  IconButton,
  Link,
  Typography,
  Toolbar,
  Box,
  Container,
} from "fashion/fabrics";
import { HomeIcon } from "fashion/icons";
import CodexLogo from "nodes/codex/CodexLogo";
import { STATIC_ROUTES } from "nodes/codex/CodexRoutes";

const LOGO_SIZE = 35;

const BlogToolbar = () => (
  <Toolbar>
    <Container>
      <Box display="flex" alignItems="center" gap={1}>
        <Box width={LOGO_SIZE} height={LOGO_SIZE}>
          <CodexLogo />
        </Box>
        <Typography variant="h5">Card Memoir Blog</Typography>
        <Box flexGrow={1} />
        <Tooltip title="Concept Home Page">
          <IconButton
            color="secondary"
            component={Link}
            href={STATIC_ROUTES.ROOT}
          >
            <HomeIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Container>
  </Toolbar>
);

export default BlogToolbar;
